module.exports = __webpack_public_path__ + "static/media/buffaloResources.3f431e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logs/buffalo/buffaloResources.png
// module id = 718
// module chunks = 0